<span [matTooltip]="alert?.toolTip ?? ''" [matTooltipDisabled]="!alert?.toolTip">
  <span class="alert-badge" [ngClass]="'alert-' + visualState">
    <i [attr.class]="'fa-solid ' + icon + ' alert-icon'"></i>
  </span>
</span>
